export const TestUsers = [
  {
    custNumber: '160323408',
    country: 'ng',
    name: 'nguser',
  },
  {
    custNumber: '245518864',
    country: 'ng',
    name: 'ng- transaction history user',
  },
  {
    custNumber: '166000789',
    country: 'ng',
    name: '1053363001 ADEROGBA',
  },
  {
    custNumber: '247032768',
    country: 'ng',
    name: '1029471757 EZEASOIBE',
  },
  {
    custNumber: '149571576',
    country: 'ng',
    name: '7036693798 TUNJI - LI - KAZLANI',
  },
  {
    custNumber: '254603350',
    country: 'ng',
    name: '1018343843 ABDULLAHI',
  },
  {
    custNumber: '253985849',
    country: 'ng',
    name: '1017550079 PRINCE',
  },
  {
    custNumber: '251210265',
    country: 'ng',
    name: '1031419248 BWALA',
  },
  {
    custNumber: '260890955',
    country: 'ng',
    name: '1025424647 SEI PELEC',
  },
  {
    custNumber: '253431740',
    country: 'ng',
    name: '1018349913 ABIODUN',
  },
  {
    custNumber: '210711103',
    country: 'ng',
    name: '8061412586 ISHAKU OTC',
  },
  {
    custNumber: '209497286',
    country: 'ng',
    name: '8061007599 JAMIU-NCII-AVATAR',
  },
  {
    custNumber: '248587161',
    country: 'ng',
    name: 'NG Premium User',
  },
  {
    custNumber: '120840373',
    country: 'ng',
    name: 'soltest15',
  },
  {
    custNumber: '73420638',
    country: 'za',
    name: 'SA Statements User',
  },
  {
    custNumber: '114263398',
    country: 'za',
    name: 'soltest36',
  },
  {
    custNumber: '120897977',
    country: 'za',
    name: 'soltest25',
  },
  {
    custNumber: '121962825',
    country: 'za',
    name: 'soltest35',
  },
  {
    custNumber: '68887468',
    country: 'za',
    name: 'ssplatform1',
  },
  {
    custNumber: '68577117',
    country: 'za',
    name: 'soltest11',
  },
  {
    custNumber: '50695819',
    country: 'za',
    name: 'soltest8',
  },
  {
    custNumber: '35828284',
    country: 'za',
    name: 'MOPS Integration',
  },
  {
    custNumber: '28798776',
    country: 'za',
    name: 'Reconnect SA User',
  },
  {
    custNumber: '53488774',
    country: 'za',
    name: 'Disconnect SA User',
  },
  {
    custNumber: '8631239',
    country: 'za',
    name: 'Any 4 subscriptions',
  },
  {
    custNumber: '93954818',
    country: 'za',
    name: 'All subscriptions',
  },
  {
    custNumber: '118830900',
    country: 'za',
    name: 'All subscriptions 2',
  },
  {
    custNumber: '10746493',
    country: 'za',
    name: 'Rewards user 1',
  },
  {
    custNumber: '8340811',
    country: 'za',
    name: 'Rewards user 2',
  },
  {
    custNumber: '984736',
    country: 'za',
    name: 'Rewards user 3',
  },
  {
    custNumber: '75913329',
    country: 'za',
    name: 'Rewards user 4',
  },
  {
    custNumber: '87792041',
    country: 'ao',
    name: 'ao user',
  },
  {
    custNumber: '127096227',
    country: 'et',
    name: 'eth user',
  },
  {
    custNumber: '131750197',
    country: 'za',
    name: 'Insurance user',
  },
  {
    custNumber: '131637534',
    country: 'za',
    name: 'Internet user 1',
  },
  {
    custNumber: '131750197',
    country: 'za',
    name: 'Internet user 2',
  },
  {
    custNumber: '110401708',
    country: 'za',
    name: 'Internet user 3',
  },
  {
    custNumber: '53488774',
    country: 'za',
    name: 'Internet user 4',
  },
  {
    custNumber: '133182758',
    country: 'za',
    name: 'Internet user 5',
  },
  {
    custNumber: '132338588',
    country: 'za',
    name: 'Internet Fibre user',
  },
  {
    custNumber: '133215130',
    country: 'za',
    name: 'Family OTT ZA',
  },
  {
    custNumber: '132233370',
    country: 'za',
    name: 'Price Lock user 1',
  },
  {
    custNumber: '78374633',
    country: 'za',
    name: 'Price Lock user 2',
  },
  {
    custNumber: '120441488',
    country: 'za',
    name: 'Price Lock user 3',
  },
  {
    custNumber: '69609584',
    country: 'za',
    name: 'Price Lock user 4',
  },
  {
    custNumber: '90765554',
    country: 'za',
    name: 'Price Lock user 5',
  },
  {
    custNumber: '73743249',
    country: 'za',
    name: 'Price Lock user 6',
  },
  {
    custNumber: '219540618',
    country: 'rw',
    name: 'Rwanda user',
  },
]